import React from 'react';
import './experience.css';
import Reveal from '../Reveal/Reveal';
import { experience } from '../../data/profile';

function Experience() {
  return (
    <section className="section" id="experience">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-eyebrow">Experience</span>
          <h2 className="section-title">Where I&apos;ve worked</h2>
          <p className="section-sub">
            Three years of building and running data platforms — from AWS and Azure
            pipelines to on-premises Cloudera, Kubernetes and OpenShift deployments.
          </p>
        </Reveal>

        <div className="timeline">
          {experience.map(({ company, duration, roles }) => (
            <Reveal as="article" key={company} className="timeline-company">
              <header className="timeline-company-head">
                <h3>{company}</h3>
                {duration && <span className="chip">{duration}</span>}
              </header>

              <ol className="timeline-roles">
                {roles.map((role, index) => (
                  <Reveal
                    as="li"
                    key={`${company}-${role.title}-${role.period}`}
                    className="timeline-role"
                    delay={index * 80}
                  >
                    <span
                      className={`timeline-marker${role.current ? ' timeline-marker--current' : ''}`}
                      aria-hidden="true"
                    />
                    <div className="timeline-role-body">
                      <h4 className="timeline-role-title">
                        {role.title}
                        {role.current && <span className="timeline-badge">Current</span>}
                      </h4>
                      <p className="timeline-role-meta">
                        {role.period} · {role.location}
                      </p>
                      <ul className="timeline-points">
                        {role.points.map((point) => (
                          <li key={point}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </Reveal>
                ))}
              </ol>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
